import Vue from 'vue'
import filters from '../../api/filters'
import localStorageHelper from '@/helpers/localStorageHelper'
import dateMixin from '@/mixins/date'

const state = () => ({
  filters: null,
  customFilter: null,
  enabledFilters: null,
  enabledCustomFilters: [],
  setDefaultFilterValue: null,
  sendRequest: true
})

// getters
const getters = {
  getListOfFilters: (state) => (currentPath) =>
  {
    if (!state.filters)
    {
      return null
    }
    try
    {
      if (state.filters)
      {
        // TODO hardcoded ids for categories! 508 - all, 510- my investments, 509 - auto-invest and invest
        const filteredFiltersByCategory = []
        let allowedCategoryShortName = ''
        const universalAllowedCategoryShortName = 'all'

        // Additional for autoinvest and strategies
        if (currentPath && currentPath.includes('/strategy/')) {
          currentPath = '/strategy'
        }

        switch (currentPath)
        {
          case '/investments':
            allowedCategoryShortName = 'my_investment'
            break
          case '/invest':
          case '/strategy':
            allowedCategoryShortName = 'invest'
            break
        }
        state.filters.filters.forEach((item) =>
          {
            const filtersCategories = []
            if (item.category_classificators)
            {
              item.category_classificators.forEach((categoryClassificator) =>
              {
                filtersCategories.push(categoryClassificator.short_name)
              }
            )
            }
            if (filtersCategories)
            {
              if (filtersCategories.includes(allowedCategoryShortName) || filtersCategories.includes(universalAllowedCategoryShortName))
              {
                filteredFiltersByCategory.push(item)
              }
            }
          }
        )
        return filteredFiltersByCategory
        // return state.filters.filters
      }
    }
    catch (e)
    {
      console.log('List of filters data get failed', e)
      return null
    }
  },
  getListOfPopularFilters: (state) =>
  {
    if (!state.filters)
    {
      return null
    }
    try
    {
      if (state.filters)
      {
        return state.filters.popular_filters
      }
    }
    catch (e)
    {
      console.log('List of populat filters data get failed', e)
      return null
    }
  },
  getListOfUserFilters: (state) =>
  {
    if (!state.filters)
    {
      return null
    }
    try
    {
      if (state.filters)
      {
        return state.filters.user_filters
      }
    }
    catch (e)
    {
      console.log('List of populat filters data get failed', e)
      return null
    }
  },
  customFilter: store => store.customFilter,
  getEnabledFilters: store => store.enabledFilters,
  getEnabledCustomFilters: store => store.enabledCustomFilters
}

// actions
const actions = {
  updateFilters({state, commit}, details)
  {
    commit('updateFilters', details)
  },
  fetchFilters({state, commit})
  {
    try
    {
      if (!state.filters)
      {
        const today = dateMixin.methods.getToday()
        // const lsFilters = localStorageHelper.getJson('filters')
        // const lsFiltersUpdated = localStorageHelper.get('filtersUpdated')
        // if (lsFilters && lsFiltersUpdated && lsFiltersUpdated !== today)
        // {
          // console.log('Using filters from lsFilters...')
          // console.log(lsFilters)
          // commit('updateFilters', lsFilters)
        // } else {
          // console.log('Send request to BE for filters...')
          filters.get().then(response =>
            {
              commit('updateFilters', response)
              // console.log('saving filters to lsFilters!...', response)
              localStorageHelper.setAsJson('filters', response)
              localStorageHelper.set('filtersUpdated', today)
            }
          )
        // }
      }
    }
    catch (e)
    {
      console.log('Failed load filters', e)
    }
  },
  clearFilters({state, commit})
  {
    try
    {
      if (state.filters)
      {
        commit('updateFilters', null)
        localStorageHelper.remove('filters')
        localStorageHelper.remove('filtersUpdated')
      }
    }
    catch (e)
    {
      console.log('Failed reset filters', e)
    }
  },
  addUserFilter({commit}, userFilter)
  {
    commit('addUserFilter', userFilter)
  },
  updateCustomFilter({commit}, customFilter)
  {
    commit('updateCustomFilter', customFilter)
  },
  updateEnabledFilters({commit}, enabledFilters)
  {
    commit('updateEnabledFilters', enabledFilters)
  },
  updateEnabledCustomFilters({commit}, enabledCustomFilters)
  {
    commit('updateEnabledCustomFilters', enabledCustomFilters)
  },
  removeEnabledCustomFilter({commit}, customFilter)
  {
    commit('removeEnabledCustomFilter', customFilter)
  },
  setDefaultValues({commit})
  {
    commit('setDefaultValues')
  },
  updateSendRequest({commit}, sendRequest)
  {
    commit('updateSendRequest', sendRequest)
  }
}

// mutations
const mutations = {
  updateFilters(state, filtersData)
  {
    Vue.set(state, 'filters', filtersData)
  },
  addUserFilter(state, userFilter)
  {
    state.filters.user_filters.push(userFilter)
  },
  updateCustomFilter(state, customFilter)
  {
    state.customFilter = customFilter
  },
  updateEnabledFilters(state, enabledFilters)
  {
    state.enabledFilters = enabledFilters
  },
  updateEnabledCustomFilters(state, customFilter)
  {
    state.enabledCustomFilters = [customFilter]
  },
  removeEnabledCustomFilter(state, customFilter)
  {
    state.setDefaultFilterValue = []
    customFilter.filters.forEach(function (cf)
    {
      let defaultValue = null
      state.filters.filters.forEach(function (f)
      {
        if (cf.id === f.id)
        {
          if (f.type === 'range')
          {
            defaultValue = f.range
          }
          else
          {
            defaultValue = f.options
          }
        }
      }, defaultValue)
      if (defaultValue)
      {
        state.setDefaultFilterValue.push({
          id: cf.id,
          values: defaultValue
        })
      }
    })
    state.enabledCustomFilters = []
  },
  setDefaultValues(state)
  {
    state.setDefaultFilterValue = state.enabledCustomFilters = []
    state.filters.filters.forEach(function (f)
    {
      let defaultValue = null
      switch (f.type) {
        case 'range':
          defaultValue = f.range
          break
        case 'multiselect':
          defaultValue = []
          break
        case 'boolean':
          defaultValue = null
          break
        case 'date_range':
          defaultValue = []
          break
        case 'text_range':
          defaultValue = null
          break
        case 'text':
          defaultValue = null
          break
        case 'yes_no':
          defaultValue = null
          break
        default:
          defaultValue = []
      }

      state.setDefaultFilterValue.push({
        id: f.id,
        values: defaultValue
      })
      // console.log(f.id, defaultValue)
    })
  },
  updateSendRequest(state, sendRequest)
  {
    state.sendRequest = sendRequest
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
